import { sendToApi } from 'api/client'
import { PaginatedApiClient } from 'api/PaginatedApiClient'

interface SignedUrl {
  url: {
    direct_upload: {
      url: string
      headers: any
    }
    blob_signed_id: string
  }
}

export interface ImportedArticle {
  id: number
  key: string
  title: string
  status: string
  accessor_info: string
  accessor_names: string[]
  location: {
    key: string
    name: string
  }
}

export interface ImportedFile {
  id: number
  filename: string
  status: string
  created_at: string
  articles: ImportedArticle[]
  top_level_folders: string[]
}

export const ImportClient = {
  getSignedUrl: (body: any, signal?: AbortSignal) => {
    return sendToApi<SignedUrl>('/presigned_urls', { method: 'POST', body, signal })
  },
  reportUploadComplete: (body: any, workspaceId: number, signal?: AbortSignal) => {
    return sendToApi<{ import_id: number }>(`/w/${workspaceId}/imports`, { method: 'POST', body, signal })
  },
  uploadTos3: (file: File, signed_url: string, headers: any, signal?: AbortSignal) => {
    return fetch(signed_url, {
      method: 'PUT',
      body: file,
      headers,
      signal,
    })
  },
  cancelImport: (import_id: number) => {
    return sendToApi<string>(`/imports/${import_id}`, {
      method: 'DELETE',
    })
  },
  getImports: (workspaceId: number, options: { items?: number } = {}) => {
    return new PaginatedApiClient<{ imports: ImportedFile[] }>(`/w/${workspaceId}/imports`, {
      method: 'GET',
    })
  },
  deleteImports: (import_ids: number[], workspaceId: number) => {
    return sendToApi<{ import_id: number }>(`/w/${workspaceId}/imports/delete_multiple`, {
      method: 'POST',
      body: { import_ids },
    })
  },
}
